<template lang='pug'>
  v-container
    v-card
      v-card-title.text-h4 Sample Elements for Macro Testing
      v-card-text
        div#getElementText Hello There
        v-text-field#getInputValue(v-model='getInputValue' persistent-hint hint='getInputValue')
</template>

<script>
export default {
  name: 'Sample',
  data() {
    return {
      getInputValue: 'getInputValue - Hello There'
    };
  }
};
</script>

<style scoped>
</style>
